// extracted by mini-css-extract-plugin
export default {"HeadFoot":"style_HeadFoot__JwjYF","header":"style_header__B5Jqi"};